import { FC } from "react";
import { Box } from "@radix-ui/themes";
import styled from "@emotion/styled";
import { Menu } from "lucide-react";
import { BaseButton } from "@/components/button";
import { MOBILE_HEADER_HEIGHT } from "@/app/layout/constants";

interface MobileHeaderProps {
  onMenuClick: () => void;
}

export const MobileHeader: FC<MobileHeaderProps> = ({ onMenuClick }) => {
  return (
    <HeaderBox>
      <MenuButton onClick={onMenuClick} aria-label="Open sidebar">
        <Menu size={20} />
      </MenuButton>
    </HeaderBox>
  );
};

const HeaderBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: ${MOBILE_HEADER_HEIGHT}px;
  padding-left: 8px;
  z-index: 2;
`;

const MenuButton = styled(BaseButton)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  background-color: var(--gray-10);
  color: var(--gray-1);
  border: none !important;
  box-shadow: none !important;

  &:hover {
    background-color: var(--gray-8);
  }

  &:active {
    background-color: var(--gray-8);
  }
`;
